import { configureStore } from '@reduxjs/toolkit';
import categoryReducer from '../stores/categorySlice';

export const store = configureStore({
  reducer: {
    category: categoryReducer,
  },
});
